import { util } from "@ax/office-shared-lib";
import * as $ from "jquery";

export namespace appElements {

    /** The content div. */
    export let contentDiv: JQuery;

    /** The attributes used for controls outside of the content div. */
    export namespace GeneralAttributes {

        /** The is shown attribute, indicating if the control or element should be shown or not. */
        export const isShown = "data-is-shown";

        /** The is active attribute, indicating if element is currently active. */
        export const isActive = "data-is-active";

        /** The expanded attribute, used on collapsible section containers to indicate when a section is expanded. */
        export const expanded = "data-expanded";
    }

    /** The attributes used for the content div. */
    export namespace ContentAttributes {

        /** The attribute which indicates the current system isn't supported. */
        export const systemNotSupported = "data-system-not-supported";

        /** The attribute which indicates the app is ready. */
        export const appReady = "data-ready";

        /** The attribute which indicates the state of authentication. */
        export const AuthenticationState = "data-authentication-state";

        /** The attribute which indicates the state of authorization. */
        export const AuthorizationState = "data-authorization-state";

        /** The attribute which indicates if manual sign in has been attempted. */
        export const ManualSignInAttempted = "data-manual-signin-attempted";

        /** The attribute which indicates if the app is in the process of signing out. */
        export const signingOut = "data-signing-out";

        /** The attribute which indicates the state of initialization for the app. */
        export const Initialized = "data-initialized";

        /** The attribute used to indicate there is an active dialog. */
        export const hasActiveDialog = "data-has-active-dialog";

        /** The attribute used to indicate the number of ready applets loaded. */
        export const appletsReadyState = "data-applets-ready-state";

        /** The attribute used to indicate if the applet selection should be shown. */
        export const appletSelectionShown = "data-applet-selection-shown";

        /** The attribute used to indicate if the applet / resource registrations have been retrieved. */
        export const registrationsRetrieved = "data-registrations-retrieved";

        /** The attribute used to indicate if any applets are currently loading. */
        export const appletsLoading = "data-applets-loading";
    }

    /** The CSS classes used in the app controls. */
    export namespace CssClasses {

        /** Class used for dialog headers. */
        export const dialogHeader = "dialogHeader";
    }

    /**
     * Changes the specified attribute on the content div to the provided state, clearing the attribute altogether if no state is provided.
     * @param attribute The attribute to change.
     * @param state The state to set the attribute's value to.
     */
    export function changeContentAttribute(attribute: string, state: any): void {
        util.changeAttribute(appElements.contentDiv, attribute, state);
    }

    /**
     * Adds a new frame to the parent element with the specified ID and src value.
     * @param parent The parent element under which to create the new frame.
     * @param frameID The ID of the new frame.
     * @param src The src value to set on the new frame.
     * @param callback The function to call once the frame is loaded.
     * @returns The newly added frame.
     */
    export function addNewFrame(parent: JQuery, frameID: string, src: string, callback?: () => void): JQuery {
        const frame = $("<iframe />", { id: frameID }).appendTo(parent); // lgtm[js/insufficient-iframe-sandboxing] -- safe use per threat model
        frame.unbind("load");
        frame.bind("load", null, function frameLoaded(event) {

            // If a callback was provided, call it
            if ($.isFunction(callback)) {
                callback();
            }
        });
        util.navigateFrame(frame, src);
        return frame;
    }
}
